import {jwtDecode} from 'jwt-decode';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { notification } from "antd";

// export const baseApiUrl = axios.create({
//   baseURL: 'http://localhost:8081/api/plateforme',
// });

export const baseApiUrl = axios.create({
  baseURL: 'https://api.ab2i.bf/api/'+'plateforme',
});

// Interceptor pour ajouter le token aux requêtes
baseApiUrl.interceptors.request.use(async (config) => {
  const token = localStorage.getItem('token');
  if (token && !isTokenExpired(token)) {
    config.headers.Authorization = `Bearer ${token}`;
  } else if (token && isTokenExpired(token)) {
    handleLogout(navigate);
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

const openNotificationWithIcon = (type, message) => {
  notification[type]({
    message: message,
  });
};

const handleLogout = async (navigate) => {
  try {
    // Récupérer le token du localStorage
    const token = localStorage.getItem("token");

    if (token) {
      // Envoyer une requête de déconnexion à l'API
      await baseApiUrl.post("/compte/deconnexion");
      console.log("Déconnexion réussie sur le serveur");
    } else {
      console.warn("Aucun token trouvé pour la déconnexion.");
    }

    // Supprimer tous les items de localStorage
    localStorage.clear();

    // Rediriger vers la page d'accueil
    navigate("/");
  } catch (error) {
    console.error("Erreur lors de la déconnexion sur le serveur:", error);
    // Assurez-vous que le localStorage est effacé même en cas d'erreur
    localStorage.clear();
    navigate("/");
  }
};


const isTokenExpired = (token) => {
  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decodedToken.exp < currentTime;
  } catch (error) {
    console.error('Erreur lors du décodage du token :', error);
    return true;
  }
};

const checkTokenValidity = async (navigate) => {
  let token = localStorage.getItem('token');
  if (token && isTokenExpired(token)) {
    console.log('Session expirée. Déconnexion...');
    await handleLogout(navigate);
    openNotificationWithIcon('error', 'Votre session a expiré. Veuillez vous reconnecter.');
    return Promise.reject('Session expirée');
  }
  return token;
};

const ApiInterceptor = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const verifyToken = async () => {
      try {
        await checkTokenValidity(navigate);
      } catch (error) {
        console.error("Erreur lors de la vérification du token :", error);
      }
    };

    verifyToken();

    const interval = setInterval(() => {
      verifyToken();
    }, 1 * 60 * 1000); // Vérifie toutes les minutes

    return () => clearInterval(interval);
  }, [navigate]);

  return <>{children}</>;
};

export default ApiInterceptor;

// Fonction pour gérer la soumission du formulaire de connexion
const handleSubmit = (e) => {
  e.preventDefault();
  setLoginFail(false);

  baseApiUrl.post("compte/connexion", login)
    .then((res) => {
      if (res.data && res.data.bearer && res.data.refresh) {
        localStorage.setItem("token", res.data.bearer);
        localStorage.setItem("refreshToken", res.data.refresh);

        console.log('data:', res.data);
        const decodedToken = jwtDecode(res.data.bearer);

        const user = {
          isAuth: true,
          id: decodedToken.id || "",
          nom: decodedToken.nom || "",
          prenom: decodedToken.prenom || "",
          photo: decodedToken.photo || "",
          role: decodedToken.roles ? decodedToken.roles[0] : "", // Assure que le rôle est défini
          exp: decodedToken.exp || "",
          token: res.data.bearer,
          refreshToken: res.data.refresh,
        };

        localStorage.setItem("user", JSON.stringify(user));

        console.log('user:', user);

        onUserChange(user);
        // Rediriger en fonction du rôle
        if (user.role === "ROLE_ADMINISTRATEUR") {
          navigate('/admin');
        } else {
          navigate('/');
        }

      } else {
        setLoginFail(true);
      }
    })
    .catch((error) => {
      setLoginFail(true);
      console.error("Erreur de connexion:", error);
    });
};
